import { render, staticRenderFns } from "./twirdora.vue?vue&type=template&id=47f1d542&"
import script from "./twirdora.vue?vue&type=script&lang=ts&"
export * from "./twirdora.vue?vue&type=script&lang=ts&"
import style0 from "./twirdora.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports